<form [formGroup]="formName">
    @if(field.attributeCode === 'radius_in_miles') {
        <p-inputNumber [allowEmpty]="true" [min]="0" maxlength="6" [placeholder]="placeholder" mode="decimal" [showButtons]="true"  [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" inputId="minmax-buttons" class="w-full"></p-inputNumber>
    }
    @else {
        <p-inputNumber [allowEmpty]="true" [min]="0" [placeholder]="placeholder" mode="decimal" [showButtons]="true"  [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" inputId="minmax-buttons" class="w-full"></p-inputNumber>
    }
</form>